import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const rolesRequest = createRequest(constants.roles);
export const rolesSuccess = createSuccess(constants.roles);
export const rolesFailure = createFailure(constants.roles);

export const requestRoles = rolesRequest;
